export const getBarOrPieData = (arrlist: any[], key = 'hoursWatched') => {
  if (!arrlist) return [];
  const dataArr: unknown[] = [];
  arrlist?.map((item) => {
    const res = item?.metric_list?.filter(
      (task: { metric: string; }) => task?.metric === key,
    );
    dataArr.push({
      app_id: item.id,
      image_url: item.cover,
      name: item.name,
      ipo_status: item.publisher,
      location_identifiers_country_code: item.publisher_address,
      source_metric_list: [
        {
          metric: 'total_revenue',
          value: res?.[0]?.value || 0,
          growth_ratio: res?.[0]?.dod || 0,
        },
      ],
    });
  });
  return dataArr;
};

export const getLineOrPieData = (arrlist: any[]) => {
  if (!arrlist) return [];
  const dataSource = arrlist.map((item) => ({
    app_id: item.id,
    id: item.id,
    image_url: item.cover,
    name: item.name,
    ipo_status: item.publisher,
    location_identifiers_country_code: item.publisher_address,
    time_line: item?.metric?.[0]?.history.map(
      (item: {
        date: any;
        data_source: any;
        value: any;
        growth_ratio: any;
      }) => ({
        time: item.date,
        metric_value_list: [
          {
            data_source: item?.data_source ?? '',
            value: item?.value,
            growth_ratio: item?.growth_ratio ?? 0,
            metric: 'total_revenue',
            growth_vaue: 0,
          },
        ],
      }),
    ),
  }));
  return dataSource;
};

export function convertNumber(number: string | number) {
  if (typeof number === 'string' && number.endsWith('%')) {
    number = number.slice(0, -1); // 去除百分号
  }
  number = parseFloat(number as string); // 转换为浮点数

  if (isNaN(number)) {
    return 0;
  }
  if (number < 0) {
    return Math.round(number);
  }
  return Math.round(number);
}

export const formattingPopupDatafn = (gameTypes: { [x: string]: unknown; }) => {
  if (typeof gameTypes !== 'object') {
    return [];
  }

  const iconRanking: { [key in string]: string } = {
    pc: 'monitor',
    mobile: 'other-icon',
    console: 'game',
  } as const;
  const sort = ['mobile', 'pc', 'console'];
  const iconList: any[] = [];
  sort.forEach((key) => {
    if (gameTypes?.[key]) {
      iconList.push({
        icon: iconRanking[key],
        gameid: gameTypes[key],
        entityType: key,
      });
    }
  });
  return iconList;
  /*
    const platform: Record<'pc' | 'mobile' | 'console' | string, string> = {
        pc: 'PC',
        mobile: 'Mobile',
        console: 'Console',
    }

    const iconRanking: { [key in string]: string } = {
        PC: 'monitor',
        Mobile: 'other-icon',
        Console: 'game',
    } as const;
    const sort = ['mobile', 'pc', 'console'];
    const hoverList: any[] = [];

    sort.forEach((key) => {
        if (gameTypes?.hasOwnProperty(key)) {
            hoverList.push({
                text: platform[key],
                value: gameTypes[key],
            });
        }
    });

    const oneIcon = iconRanking[hoverList?.[0]?.text] as string;
    return [hoverList.length <= 1 ? undefined : hoverList, [oneIcon]];
    */
};

// 【PC情报】【Funcom】 情报直播页面增加游戏类型筛选器，直播榜单页，多个icon都展示出来
export const streamingGetIconJumpPayload = (
  gameTypeObj: { [type: string]: string; },
  iconEntityType: string,
) => {
  // 点了mobile icon 进入mobile游戏平台页面
  // 点了pc icon 	优先进入pc & console 游戏平台页面, 只有PC则进入PC【console同理】
  if (typeof gameTypeObj !== 'object') {
    return;
  }
  const typeKeys = Object.keys(gameTypeObj);
  const isCombine = ['pc', 'console', 'combine'].every((element) =>
    typeKeys.includes(element),
  );
  if (iconEntityType !== 'mobile' && isCombine) {
    return { combine: gameTypeObj?.combine };
  }
  return { [iconEntityType]: gameTypeObj?.[iconEntityType] };
};

// 【PC情报】【Funcom】 情报直播页面增加游戏类型筛选器，直播榜单页，多个icon都展示出来
export const streamingGetPictureJumpPayload = (gameTypeObj: {
  [type: string]: string;
}) => {
  if (typeof gameTypeObj !== 'object') {
    return;
  }
  const typeKeys = Object.keys(gameTypeObj);
  const isCombine = ['pc', 'console', 'combine'].every((element) =>
    typeKeys.includes(element),
  );
  // PC&Console
  if (isCombine) {
    return { combine: gameTypeObj?.combine };
  }
  // Mobile
  if (typeKeys.every((element) => ['mobile', 'combine'].includes(element))) {
    return { mobile: gameTypeObj?.mobile };
  }
  // PC Mobile PC&Console
  if (
    typeKeys.every((element) => ['mobile', 'pc', 'combine'].includes(element))
  ) {
    return { pc: gameTypeObj?.pc };
  }
  if (
    typeKeys.every((element) =>
      ['mobile', 'console', 'combine'].includes(element),
    )
  ) {
    return { console: gameTypeObj?.console };
  }
  // 把combine的去掉,因为已经判断过是否使用combine了
  const firstKey = typeKeys.find((key) => key !== 'combine');
  return firstKey ? { [firstKey]: gameTypeObj?.[firstKey] } : {};
};
